const homeSx = theme => ({
	flexContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		boxSizing: 'border-box',
		width: '100%',
	},
});

export default homeSx;
